import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "../components/DashboardLayout";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { Plus, Briefcase } from "lucide-react";

export default function Matters() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/matters").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const filtered = items.filter((m) => (m.title || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <div className="kicker">Dikigoros.io</div>
          <h1 className="mt-2 font-display font-bold text-3xl md:text-4xl text-slate-900">{t("dash.matters")}</h1>
        </div>
        <Link to="/new-analysis" className="btn-primary rounded-full px-5 py-2.5 text-sm font-semibold inline-flex items-center gap-2" data-testid="matters-new">
          <Plus className="h-4 w-4" /> {t("matter.createTitle")}
        </Link>
      </div>

      <div className="mt-8">
        <input
          placeholder={lang === "el" ? "Αναζήτηση…" : "Search…"}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="w-full sm:max-w-sm rounded-full border border-slate-300 bg-white px-4 py-2.5 focus:border-[#0A192F] focus:ring-1 focus:ring-[#0A192F] outline-none transition text-sm"
          data-testid="matters-search"
        />
      </div>

      <div className="mt-8">
        {filtered.length === 0 ? (
          <div className="card-premium p-12 text-center" data-testid="matters-empty">
            <Briefcase className="h-8 w-8 text-slate-300 mx-auto" />
            <div className="mt-3 text-slate-500 text-sm">{t("dash.noMatters")}</div>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((m) => (
              <Link to={`/matters/${m.id}`} key={m.id} className="card-premium p-6 block" data-testid={`matter-card-${m.id}`}>
                <div className="text-[10px] tracking-[0.22em] uppercase font-bold text-[#8B1E3F]">Matter</div>
                <div className="mt-2 font-display font-bold text-xl text-slate-900 leading-tight">{m.title}</div>
                {m.tags?.length > 0 && (
                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {m.tags.slice(0, 4).map((t) => (
                      <span key={t} className="text-[11px] bg-slate-100 text-slate-600 rounded-full px-2 py-0.5">{t}</span>
                    ))}
                  </div>
                )}
                <div className="mt-4 flex gap-4 text-xs text-slate-500">
                  <div>{m.document_count} docs</div>
                  <div>{m.report_count} reports</div>
                  <div>{new Date(m.updated_at).toLocaleDateString()}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
